<script setup>
import { computed } from "vue";

// Кнопка «Telegram» — по аналогии с MaxButton. Цель Метрики задаётся пропом goal.
// flat — второстепенная кнопка дизайн-системы (серая рамка). iconOnly — только
// квадратный значок без подписи (мобильная строка контактов, рядом с MAX).
const props = defineProps({
  href: { type: String, default: "" },
  flat: { type: Boolean, default: false },
  iconOnly: { type: Boolean, default: false },
  label: { type: String, default: "Telegram" },
  goal: { type: String, default: "TG_Click" },
});

function track() {
  if (typeof window !== "undefined" && window.goal) window.goal(props.goal);
}

// Дописываем протокол, если ссылку вставили без него
const link = computed(() => {
  const m = (props.href ?? "").trim();
  if (!m) return "";
  return /^https?:\/\//i.test(m) ? m : "https://" + m;
});
</script>

<template>
  <a v-if="link" :href="link" target="_blank" rel="noopener"
    @click="track"
    title="Написать юристу в Telegram"
    class="inline-flex items-center justify-center bg-white font-medium"
    :class="iconOnly
      ? 'border border-gray-300 bg-gray-50 shadow-sm rounded-xl hover:bg-gray-100 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
      : (flat
        ? 'gap-2 text-gray-700 border border-gray-300 py-2.5 px-3 rounded-lg hover:bg-gray-50 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
        : 'gap-2 text-gray-900 border border-gray-200 py-3 px-5 rounded-xl shadow-lg hover:scale-105 transition-all duration-300')">
    <!-- Значок Telegram -->
    <svg class="shrink-0 rounded-[6px]" :class="iconOnly ? 'w-8 h-8' : (flat ? 'w-5 h-5' : 'w-6 h-6')"
      viewBox="0 0 240 240" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="240" height="240" rx="56" fill="#2AABEE" />
      <path fill="#fff"
        d="M180.6 71.3l-23.4 110.4c-1.7 7.8-6.4 9.7-12.9 6l-35.7-26.3-17.2 16.6c-1.9 1.9-3.5 3.5-7.2 3.5l2.6-36.5 66.4-60c2.9-2.6-.6-4-4.5-1.4l-82 51.7-35.3-11c-7.7-2.4-7.8-7.7 1.6-11.4l137.9-53.2c6.4-2.3 12 1.6 9.4 11.3z" />
    </svg>
    <span v-if="!iconOnly" class="font-semibold text-sm leading-tight whitespace-nowrap">{{ label }}</span>
  </a>
</template>
